import React from "react";
import { isLookSystem } from "@/utils/look-gate";

/** A policy section's h1 on the look system: the stored heading, or the policy's name until one is written. */
export default function PolicyHeading({
  theme,
  heading,
  fallback,
}: {
  theme: unknown;
  heading: unknown;
  fallback: string;
}) {
  if (!isLookSystem(theme)) return null;
  const text =
    typeof heading === "string" && heading.trim() ? heading.trim() : fallback;
  return (
    <h1
      data-policy-heading=""
      className="w-full text-left homepage-text-2xl md:homepage-text-4xl primary-font text-[color:var(--page-text-heading-color)]"
    >
      {text}
    </h1>
  );
}
